import { render, staticRenderFns } from "./levelinfoadd.vue?vue&type=template&id=d0345a44&scoped=true"
import script from "./levelinfoadd.vue?vue&type=script&lang=js"
export * from "./levelinfoadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0345a44",
  null
  
)

export default component.exports